<template>
  <div class="BipedReport">
    <img src="/biped/biped-vignette-rapport.png" style="width: 100%; margin-bottom: 20px"/>
    <div v-show="showFullScreenSlot">
      <div v-if="showFullScreenSlot" @keyup.esc="showFullScreenSlot = false"></div>
      <v-overlay z-index="6" opacity="0.7">
        <v-icon style="position: fixed; top: 30px; right: 30px" @click.stop="showFullScreenSlot = false">close</v-icon>
        <v-img :aspect-ratio="9/16" style="transform: rotate(90deg); width: 90vh; max-height: 90vw;" :src="fullSizeSingleSrc"/>
      </v-overlay>
    </div>

    <div class="my-12">
      <h2>Notes sur le patient :</h2>
      <span>Il s'agit d'une note partagée entre tous les médecins ayant accès au dossier de ce patient.</span>
      <v-divider></v-divider>
      <v-textarea class="my-3" outlined v-model="notes_doc"></v-textarea>
      <div style="display: flex; flex-direction: row">
        <v-btn :loading="note_loading" @click="saveNotesPatient()" class="mr-2" color="success" :disabled="notes_doc === report.data.notes_doc">Enregistrer</v-btn>
        <v-btn :loading="note_loading" @click="notes_doc = report.data.notes_doc" color="error" :disabled="notes_doc === report.data.notes_doc">Annuler</v-btn>
      </div>
    </div>

    <div class="my-12">
      <h2>Historique des alertes de ce patient : </h2>
      <span>Liste de toutes les alertes de ce patient.</span>
      <v-divider></v-divider>
      <span style="font-size: 20px" v-if="alertes.length === 0">Aucune alerte pour ce patient</span>
      <v-simple-table v-else class="my-3">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-left">#</th>
            <th class="text-left">Date de création</th>
            <th>Traitement</th>
            <th>Commentaires</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="alert in alertes"
              :key="alert.id">
            <td><span>{{alert.plaie_id}}</span></td>
            <td>{{ alert.created_at | moment('L - LT') }}</td>
            <td>
              <span v-if="alert.seen_at">Traitée par {{alert.doctor.first_name}} {{alert.doctor.last_name}} le {{alert.seen_at | moment('L à LT')}}</span>
            </td>
            <td>
              {{alert.seen_comments}}
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <div class="my-12">
      <h2>Galerie d'images</h2>
      <v-divider></v-divider>
      <div id="fullSizeImages" class="my-3" style="display: flex; flex-direction: row; position: relative;">
        <div style="display: flex; flex-direction: column; min-width:50%; max-width:50%; min-height: 96vh; border: solid 1px black;">
          <v-img :aspect-ratio="16/9" contain class="fullSize" style="margin-left: auto; height: 96vh;" @click="openInFullScreen()" :src="fullSizeLeftSrc" v-if="fullSizeLeftMedia !== null"/>
          <div style="position: relative; min-height: 200px;">
            <p style="padding: 15px; white-space: pre-line;" v-show="!editLeft" v-html="fullSizeLeftMedia ? fullSizeLeftMedia['custom_properties'].commentaire : ''"></p>
            <div v-show="editLeft">
              <v-textarea v-model="editCommLeft"></v-textarea>
              <v-btn @click="editComm(true,false, false)">Annuler</v-btn>
              <v-btn @click="editComm(true, false, true)">Valider</v-btn>
            </div>
            <v-icon v-show="fullSizeLeftMedia !== null" @click="editComm()" style="position: absolute; top: 10px; right: 10px;">edit</v-icon>
          </div>
        </div>
        <div style="display: flex; flex-direction: column; min-width:50%; max-width:50%; min-height: 96vh; border: solid 1px black;">
          <v-img :aspect-ratio="9/16" contain class="fullSize" style="margin-right: auto; height: 96vh;"  @click="openInFullScreen(false)" :src="fullSizeRightSrc" v-if="fullSizeRightMedia !== null"/>
          <div style="position: relative; min-height: 200px;">
            <p style="padding: 15px; white-space: pre-line;" v-show="!editRight" v-html="fullSizeRightMedia ? fullSizeRightMedia['custom_properties'].commentaire : ''"></p>
            <div v-show="editRight">
              <v-textarea v-model="editCommRight"></v-textarea>
              <v-btn @click="editComm(false, false, false)">Annuler</v-btn>
              <v-btn @click="editComm(false, false, true)">Valider</v-btn>
            </div>
            <v-icon v-show="(fullSizeRightMedia !== null)" @click="editComm(false)" style="position: absolute; top: 10px; right: 10px;">edit</v-icon>
          </div>
        </div>
      </div>

      <div class="my-9">
        <h2>Liste des plaies de ce patient : </h2>
        <span>Liste des toutes les plaies déclarées de ce patient. Vous pouvez sélectionner et déselectionner des plaies pour respectivement afficher et masquer les photos associées à ces plaies dans la galerie d'images.</span>
        <v-divider></v-divider>
        <div style="display: flex; flex-direction: row; align-items: center;">
          <h5 class="mr-3">Afficher les plaies archivées : </h5>
          <v-checkbox v-model="showArchivedPlaies"></v-checkbox>
        </div>
        <v-simple-table class="my-3">
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-left">Gérer la plaie</th>
              <th class="text-left">#</th>
              <th class="text-left">Date de création</th>
              <th class="text-left">Côté</th>
              <th class="text-left">Localisation</th>
              <th class="text-left">Plaie d'amputation</th>
              <th class="text-left">Aspect de la plaie</th>
              <th class="text-left">Aspect de la peau</th>
              <th class="text-left">Taille de la plaie</th>
              <th class="text-left">Tendon ou os atteint</th>
              <th class="text-left">Commentaire</th>
              <th class="text-left">Commentaire d'archivage</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="plaie in plaies"
                :key="plaie.id"
                v-show="showArchivedPlaies || plaie.archived_by_doctor_id === null">
              <td>
                <span style="display: flex; flex-direction: row; align-items: center">
                  <v-checkbox v-model="plaie.galerie"></v-checkbox>
                  <div class="tooltip">
                    <v-icon @click="openDialog(plaie.id)" tooltip="archiver la plaie">archive</v-icon>
                    <span class="tooltiptext">Archiver cette plaie</span>
                  </div>
                </span>
              </td>
              <td>{{plaie.id}}</td>
              <td>{{plaie.created_at | moment('L - LT') }}</td>
              <td>{{(plaie.cote === 0) ? 'Droit' : (plaie.cote === 1) ? 'Gauche' : 'Bilatérale'}}</td>
              <td>{{(plaie.location === 0) ? 'Orteils' : (plaie.location === 1) ? 'Avant pied' : (plaie.location === 2) ? 'Médiopied' : 'Talon'}}</td>
              <td>{{(plaie.amputation === 0) ? 'Oui' : 'Non'}}</td>
              <td>{{(plaie.aspectPlaie === 0) ? 'Propre' : (plaie.aspectPlaie === 1) ? 'Fibrineuse' : (plaie.aspectPlaie === 2) ? 'Nécrotique' : (plaie.aspectPlaie === 3) ? 'Hémorragique' : 'Purulente'}}</td>
              <td>{{(plaie.aspectPeau === 0) ? 'Propre' : 'Hyperkératosique'}}</td>
              <td>{{(plaie.taillePlaie === 0) ? 'Moins de 1cm²' : 'Plus de 1cm²'}}</td>
              <td>{{(plaie.tendonOsAtteint === 0) ? 'Oui' : 'Non'}}</td>
              <td>{{plaie.commentaire}}</td>
              <td>{{plaie.archived_comm}}</td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>

      <div id="filters" style="display: flex; flex-direction: column;">
        <div style="display: flex; flex-direction: row; align-items: center">
          <v-checkbox label="Afficher uniquement les favoris" v-model="showOnlyFavorite"></v-checkbox>
        </div>
        <div>
          <div style="display: flex; flex-direction: row; align-items: center">
            <p class="mr-3">Recherche tous-champs : </p>
            <v-text-field v-model="searchSentence" solo @input="search($event)"></v-text-field>
          </div>
        </div>
      </div>

      <div style="font-style: italic" class="my-4">Pour comparer deux images cliquez sur l'icône <v-icon color="white" style="background-color: black; transform: scaleX(-1);">compare</v-icon> pour afficher une image à gauche, et sur l'icône <v-icon color="white" style="background-color: black;">compare</v-icon> pour afficher une image à droite.</div>
      <v-expansion-panels v-model="panels" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>Galerie d'images</v-expansion-panel-header>
          <v-expansion-panel-content>
            <div id="thumbGallerie"
                 style="display: flex; flex-direction: row; align-items: center; overflow-x: scroll;">
              <div class="imgSlot px-2" v-for="(media, index) in mediasShown" @mouseover="set(hovers, index, true)"
                   @mouseleave="set(hovers, index, false)"
                   v-show="inSearchWords(media) && (!showOnlyFavorite || media['custom_properties']['favorite']) && (findPlaie(media.custom_properties.plaie_id).galerie)"
                   :style="{'width': '200px', 'border': (report.patient.application_profile.lastSeen === null || report.patient.application_profile.lastSeen <= media.created_at) ? 'solid 1px blue' : 'solid 0px blue'}">
                <img :id="media.id" class="thumbnail mx-2" :src="media.src"/>
                <div style="margin-top: 0; padding: 5px;">{{media['custom_properties'].date | moment('LL LT')}}</div>
                <div v-show="hovers[index]"
                     style="background: rgba(173,216,230, 0.5); width: 100%; height: 100%; position: absolute; top: 0; left: 0; margin-bottom: 20px">
                  <v-icon @click.stop="hideImage(index)" style="position:absolute;left:10px;top:10px; background-color: black"
                          color="white">visibility_off
                  </v-icon>
                  <v-icon @click.stop="getFullSize(0, index)"
                          style="position:absolute;left:10px;bottom:45px; background-color: black; transform: scaleX(-1)" color="white">
                    compare
                  </v-icon>
                  <v-icon @click.stop="getFullSize(1, index)"
                          style="position:absolute;right:10px;bottom:45px; background-color: black;" color="white">
                    compare
                  </v-icon>
                </div>
                <v-icon v-show="!media['custom_properties']['favorite']"
                        @click.stop="favorite(index, true)"
                        style="position:absolute;right:5px;bottom:5px;" color="#FFD700">
                  star_border
                </v-icon>
                <v-icon v-show="media['custom_properties']['favorite']"
                        @click.stop="favorite(index, false)"
                        style="position:absolute;right:5px;bottom:5px;" color="#FFD700">
                  star
                </v-icon>
                <v-icon v-show="!!media['custom_properties']['commentaire']"
                        style="position:absolute;right:10px;top:10px; background-color: black" color="white">chat
                </v-icon>
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>Images masquées</v-expansion-panel-header>
          <v-expansion-panel-content>
            <div id="thumbGallerieHidden"
                 style="display: flex; flex-direction: row; align-items: center; overflow-x: scroll;">
              <div class="imgSlot px-2" v-for="(media, index) in mediasHidden"
                   @mouseover="set(hoversHidden, index, true)" @mouseleave="set(hoversHidden, index, false)"
                   v-show="inSearchWords(media) && (!showOnlyFavorite || media['custom_properties']['favorite']) && (findPlaie(media.custom_properties.plaie_id).galerie)"
                   style="width: 200px">
                <img class="thumbnail mx-2" :src="media.src"/>
                <div style="margin-top: 0; padding: 5px;">{{media['custom_properties'].date | moment('LL LT')}}</div>
                <div v-show="hoversHidden[index]"
                     style="background: rgba(173,216,230, 0.5); width: 100%; height: 100%; position: absolute; top: 0; left: 0; margin-bottom: 20px">
                  <v-icon @click.stop="hideImage(index, false)" style="position:absolute;left:10px;top:10px; background-color: black"
                          color="white">visibility
                  </v-icon>
                  <v-icon @click.stop="getFullSize(0, index)"
                          style="position:absolute;left:10px;bottom:45px; background-color: black; transform: scaleX(-1)" color="white">
                    compare
                  </v-icon>
                  <v-icon @click.stop="getFullSize(1, index)"
                          style="position:absolute;right:10px;bottom:45px; background-color: black;" color="white">
                    compare
                  </v-icon>
                </div>
                <v-icon v-show="!media['custom_properties']['favorite']"
                        @click.stop="favorite(index, true, true)"
                        style="position:absolute;right:10px;bottom:10px;" color="#FFD700">
                  star_border
                </v-icon>
                <v-icon v-show="media['custom_properties']['favorite']"
                        @click.stop="favorite(index, false, true)"
                        style="position:absolute;right:10px;bottom:10px;" color="#FFD700">
                  star
                </v-icon>
                <v-icon v-show="!!media['custom_properties']['commentaire']"
                        style="position:absolute;right:10px;top:10px; background-color: black" color="white">
                  chat
                </v-icon>
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <div class="my-12">
      <h2>Données des missions :</h2>
      <v-divider></v-divider>

      <div v-if="report.data.mission !== null">
        <h3 class="my-3"> Mission « {{report.data.mission.module.label}} »</h3>
        <div v-if="report.data.mission.done_at !== null">
          <div class="BlocQR">
            <div class="Question">Quel est votre type de diabète ?</div>
            <span class="Reponse" v-if="missionData.typeDiabete === 0">Type 1</span>
            <span class="Reponse" v-else-if="missionData.typeDiabete === 1">Type 2</span>
            <span class="Reponse" v-else>Autre</span>
          </div>

          <div class="BlocQR">
            <div class="Question">En quelle année a débuté votre diabète ?</div>
            <span class="Reponse">{{missionData.anneeDebutDiabete}}</span>
          </div>

          <div class="BlocQR">
            <div class="Question">Avez-vous un traitement par insuline ?</div>
            <span class="Reponse" v-if="missionData.traitementInsuline === 0">Oui</span>
            <span class="Reponse" v-else-if="missionData.traitementInsuline === 1">Non</span>
          </div>

          <div class="BlocQR">
            <div class="Question">Avez-vous été dialysé•e ?</div>
            <span class="Reponse" v-if="missionData.dialyse === 0">Oui</span>
            <span class="Reponse" v-else-if="missionData.dialyse === 1">Non</span>
          </div>
        </div>
        <div v-else>
          <span>Le patient n'a pas encore répondu à ce quetionnaire.</span>
        </div>
      </div>
      <div v-else>
        Le patient n'a pas encore répondu à sa mission questionnaire.
      </div>
    </div>

    <IriadeSettingsDialog :show="dialog_archive">
      <v-card>
        <v-card-title class="headline primary white--text"
                      style="display: flex; justify-content: space-between">
          <span>Archiver la plaie n°{{dialog.plaie_id}}</span>
          <span class="pointer"
                @click="closeDialogArchive">X</span>
        </v-card-title>
        <v-card-text class="pt-7">
          <MangoCaption>Vous pouvez entrer un commentaire optionnel pour archiver cette plaie.</MangoCaption>
          <IriadeTextarea label="Commentaires"
                          v-model="dialog.commentaire"></IriadeTextarea>
        </v-card-text>
        <v-card-actions>
          <v-btn :disabled="dialog.cloture === null"
                 block
                 class="primary"
                 :loading="dialog.loading"
                 @click="archiverPlaie(dialog.plaie_id)">Valider la mission
          </v-btn>
        </v-card-actions>
      </v-card>
    </IriadeSettingsDialog>

  </div>
</template>

<script>
  import Vue from 'vue'
  import api from 'api'
  import moment from 'moment'
  import MissionHeaderBlock from 'components/blocks/MissionHeaderBlock'
  import ParagraphBlock from 'components/blocks/ParagraphBlock'
  import SubHeaderBlock from 'components/blocks/SubHeaderBlock'


  export default {
    components: {
      SubHeaderBlock,
      MissionHeaderBlock,
      ParagraphBlock
    },

    data() {
      return {
        searchSentence: "",
        searchWords: [""],
        mediasShown: [],
        mediasHidden: [],
        fileTest: null,
        hovers: [],
        hoversHidden: [],
        editLeft: false,
        editRight: false,
        fullSizeLeftIndex: null,
        fullSizeLeftHidden: false,
        fullSizeLeftMedia: null,
        fullSizeRightIndex: null,
        fullSizeRightHidden: false,
        fullSizeRightMedia: null,
        commLeft: "",
        editCommLeft: "",
        commRight: "",
        editCommRight: "",
        panels: [0],
        loadedMedias: 0,
        loadedPlaies: 0,
        showFullScreenSlot: false,
        showOnlyFavorite: false,
        fullSizeSingleSrc: "",
        fullSizeLeftSrc: "",
        fullSizeRightSrc: "",

        notes_doc: "",
        note_loading: false,

        showArchivedPlaies: false,
        dialog_archive: false,

        plaies: [],

        dialog: {
          commentaire: null,
          plaie_id: null,
        }
      }
    },

    computed: {
      alertes() {
        let alertes = [];

        let tmp = this.plaies.map(function(e) {
          return e.alerts;
        });

        for (let i in tmp) {
          for (let j in tmp[i]) {
            alertes.push(tmp[i][j]);
          }
        }

        return alertes.sort(function (a, b) {
          if (a.seen_at === null && b.seen_at !== null) {
            return -1;
          }

          if (a.seen_at !== null && b.seen_at === null) {
            return 1;
          }

          if (a.created_at < b.created_at) {
            return 1;
          } else {
            return -1;
          }
        })
      },

      missionData() {
        return this.report.data.mission.data;
      },
    },

    methods: {
      archiverPlaie(plaie_id) {
        api.post(`biped/plaie/archiver`, {commentaire: this.dialog.commentaire, plaie_id: plaie_id})
        .then(_ => {
          let p = this.plaies.find(function (e) {
            return e.id === this;
          }, plaie_id);
          p.archived_by_doctor_id = this.report.data.doctor_id;
          p.archived_comm = this.dialog.commentaire;
          this.closeDialogArchive();
        })
        .catch(err => {
          console.log(err);
        });
      },

      closeDialogArchive() {
        this.dialog = {
          commentaire: null,
          plaie_id: null,
        };
        this.dialog_archive = false;
      },

      openDialog(plaie_id) {
        this.dialog.plaie_id = plaie_id;
        this.dialog_archive = true;
      },

      saveNotesPatient() {
        this.note_loading = true;
        api.post(`biped/note/${this.report.data.patient_id}`, {notes_patient: this.notes_doc})
          .then(_ => {
            this.$mango.snackbar({
              color: 'success',
              text: "Note enregistrée."
            });
            this.report.data.notes_doc = this.notes_doc;
          })
          .catch(_ => {
            this.$mango.snackbar({
              color: 'error',
              text: "Une erreur est survenue pendant l'enregistrement de la note."
            });
          })
      },

      findPlaie(id) {
        return this.plaies.find(function (e) {
          return this === e.id;
        }, id);
      },

      search(event) {
        this.searchWords = event.split(' ');
      },

      inSearchWords(media) {
        if (this.searchWords[0] === "") {
          return true;
        }

        let found = true;

        for (let i in this.searchWords) {
          let atLeastOne = false;
          let word = this.searchWords[i];
          let comm = media.custom_properties.commentaire;
          atLeastOne |= (comm !== null && comm.includes(word));

          atLeastOne |= moment(media.custom_properties.date).format('LL').includes(word);

          found &= atLeastOne;
        }

        return found;
      },

      favorite(index, favorite, hidden = false) {
        let media = null;

        if (hidden) {
          media = this.mediasHidden[index];
        } else {
          media = this.mediasShown[index];
        }

        media['custom_properties']['favorite'] = favorite;

        api.post('biped/media/property/' + media.custom_properties.plaie_id + "/" + media.id, {'property_name': 'favorite', 'property_value': favorite});
      },

      openInFullScreen(left = true) {
        let imgSrc = null;
        if (left) {
          imgSrc = this.fullSizeLeftSrc;
        } else {
          imgSrc = this.fullSizeRightSrc;
        }

        if (imgSrc === null) {
          return;
        }

        this.showFullScreenSlot = true;
        this.fullSizeSingleSrc = imgSrc;
      },

      hideImage(index, hide = true) {
        let inputList = [];
        let outputList = [];
        if (hide) {
          inputList = this.mediasHidden;
          outputList = this.mediasShown;
        } else {
          outputList = this.mediasHidden;
          inputList = this.mediasShown;
        }

        let media = outputList.splice(index, 1)[0];

        inputList.push(media);
        this.sortMediaList(inputList);

        api.post('biped/media/property/' + media.custom_properties.plaie_id + "/" + media.id, {'property_name': 'hidden', 'property_value': hide});
      },

      fileChange(event) {
        this.fileTest = event.target.files[0];
      },

      uploadFile() {

        let formData = new FormData();
        formData.append('file', this.fileTest);
        formData.append('commentaire', "Un commentaire super cool");
        formData.append('date', (new Date()).toUTCString())
        api.post('biped/media/' + this.report.data['patient_id'], formData, {headers: {'Content-Type': 'multipart/form-data'}});
      },

      getFullSize(side, index, hidden = false) {
        let media = null;
        if (hidden) {
          media = this.mediasHidden[index];
        } else {
          media = this.mediasShown[index];
        }

        api.get('biped/media/' + media.custom_properties.plaie_id + "/" + media.id).then(res => {
          if (side) {
            this.fullSizeRightSrc = res.data;
            this.fullSizeRightIndex = index;
            this.commRight = media['custom_properties'].commentaire;
            this.fullSizeRightMedia = media;
            this.fullSizeRightHidden = hidden;
          } else {
            this.fullSizeLeftSrc = res.data;
            this.fullSizeLeftIndex = index;
            this.commLeft = media['custom_properties'].commentaire;
            this.fullSizeLeftMedia = media;
            this.fullSizeLeftHidden = hidden;
          }
        })
      },

      nl2br (str) {
        let breakTag = '<br />';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
      },

      set(table, index, value) {
        Vue.set(table, index, value)
      },

      editComm(left = true, start = true, save = false) {
        let media = null;
        if (left) {
          media = (this.fullSizeLeftHidden) ? this.mediasHidden[this.fullSizeLeftIndex] : this.mediasShown[this.fullSizeLeftIndex];
        } else {
          media = (this.fullSizeRightHidden) ? this.mediasHidden[this.fullSizeRightIndex] : this.mediasShown[this.fullSizeRightIndex];
        }

        if (start) { //Start editing
          if (left) {
            this.editLeft = true;
            this.editCommLeft = media['custom_properties'].commentaire;
          } else {
            this.editRight = true;
            this.editCommRight = media['custom_properties'].commentaire;
          }
        } else { // Finish editing (either save or cancel)
          if (left) {
            this.editLeft = false;
            if (save) {
              api.post('biped/media/property/' + media.custom_properties.plaie_id + "/" + media.id, {'property_name': 'commentaire', 'property_value': (this.editCommLeft !== null ? this.editCommLeft : '')});
              if (this.fullSizeLeftHidden) {
                this.mediasHidden[this.fullSizeLeftIndex].custom_properties.commentaire = this.editCommLeft;
              } else {
                this.mediasShown[this.fullSizeLeftIndex].custom_properties.commentaire = this.editCommLeft;
              }
              this.fullSizeLeftMedia.custom_properties.commentaire = this.editCommLeft;
            }
            this.editCommLeft = "";
          } else {
            this.editRight = false;
            if (save) {
              api.post('biped/media/property/' + media.custom_properties.plaie_id + "/" + media.id, {'property_name': 'commentaire', 'property_value': (this.editCommRight !== null ? this.editCommRight : '')});
              if (this.fullSizeRightHidden) {
                this.mediasHidden[this.fullSizeRightIndex].custom_properties.commentaire = this.editCommRight;
              } else {
                this.mediasShown[this.fullSizeRightIndex].custom_properties.commentaire = this.editCommRight;
              }
              this.fullSizeRightMedia.custom_properties.commentaire = this.editCommRight;
            }
            this.editCommRight = "";
          }
        }
      },

      sortMediaList(list, anteChrono = true) {
        list.sort((a, b) => { return ((anteChrono) ? 1 : -1) * ((moment(a.custom_properties.date) < moment(b.custom_properties.date)) ? 1 : -1); });
      },

      loadMediasThumb() {
        if (this.plaies.length === 0) {
          return;
        }


        let plaie_id = this.plaies[this.loadedPlaies].id;


        if (this.loadedMedias === this.report.data.medias[plaie_id].length) {
          this.loadedMedias = 0;
          ++this.loadedPlaies;
        }

        if (this.loadedPlaies === this.plaies.length) {
          this.loadedPlaies = 0;

          this.sortMediaList(this.mediasHidden);
          this.sortMediaList(this.mediasShown);

          let i = 0;
          let side = false;

          for (let m_id in this.mediasShown) {
            let m = this.mediasShown[m_id];
            let p = this.plaies.filter(function (e) { return e.id === m.custom_properties.plaie_id });

            if (p.length > 0 && p[0].archived_at === null) {
              this.getFullSize(side, i, false);
              if (side) {
                return;
              }
              side = true;
            }
            ++i;
          }

          return;
        }

        plaie_id = this.plaies[this.loadedPlaies].id;

        let media = this.report.data.medias[plaie_id][this.loadedMedias];

        media.src = null;

        let index;

        if (media.custom_properties.hidden) {
          index = this.mediasHidden.push(media) - 1;
        } else {
          index = this.mediasShown.push(media) - 1;
        }

        //console.log("-> " + this.loadedPlaies + "/" + this.plaies.length + " " + this.loadedMedias + "/" + this.report.data.medias[plaie_id].length);
        console.log("-> " + plaie_id + " " + media.id);

        api.get('biped/thumb/' + plaie_id + '/' + media.id).then(res => {
          if (media.custom_properties.hidden) {
            this.set(this.mediasHidden[index], 'src', res.data)
          } else {
            this.set(this.mediasShown[index], 'src', res.data)
          }
        })
          .then(_ => {
            this.loadedMedias++;
            this.loadMediasThumb()
          })
          .catch(_ => {
            this.loadedMedias++;
            this.loadMediasThumb()
          });
      }
    },

    mounted() {
      this.plaies = this.report.data.plaies;

      for(let i in this.plaies) {
        let plaie = this.plaies[i];

        plaie.galerie = plaie.archived_by_doctor_id === null;
      }

      this.loadMediasThumb();

      this.notes_doc = this.report.data.notes_doc;
    },

    props: {
      report: {
        required: true,
        type: Object
      }
    }
  }
</script>

<style lang="scss"
       type="text/scss">
  .BipedReport {
    font-size: 16px;

    .BlocQR {
      margin-bottom: 25px;
    }

    .Reponse {
      font-weight: bold;
      margin-left: 10px;
    }

    .Question {
    }

    .imgSlot {
      position: relative;
      margin-bottom: 20px;
    }

    .thumbnail {
      width: 153px;
      height: 224px;
    }

    .fullSize {
      object-fit: scale-down;
      min-width: 54vh;
      height: 96vh;
      width: auto;
      margin: 0px 5px;
    }

    .tooltip {
      position: relative;
      display: inline-block;
      border-bottom: 1px dotted black;
    }

    .tooltip .tooltiptext {
      visibility: hidden;
      width: 120px;
      background-color: #555;
      color: #fff;
      text-align: center;
      border-radius: 6px;
      padding: 5px 0;
      position: absolute;
      z-index: 1;
      bottom: 125%;
      left: 50%;
      margin-left: -60px;
      opacity: 0;
      transition: opacity 0.3s;
    }

    .tooltip .tooltiptext::after {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: #555 transparent transparent transparent;
    }

    .tooltip:hover .tooltiptext {
      visibility: visible;
      opacity: 1;
    }
  }
</style>
